import { useContext, useEffect, useState } from "react";
import AddTransaction from "./AddTransaction/AddTransaction";
import { MainContext } from "../../../MainContext";
import { TransactionList } from "./TransactionList/TransactionList";
import CollapsableBox from "../../CollapsibleBox/CollapsableBox";
import { request } from "../../../request";
import { Box, CircularProgress, Paper, Stack, TextField, InputAdornment, Autocomplete, Button, Slider, Typography, useMediaQuery } from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TransactionListPrev } from "./TransactionList/TransactionListPrev";
import History from "./History/History";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Datepicker.scss";
import { icons } from "../../../icons";
import MoneyInput from "../Inputs/MoneyInput";
import Swal from "sweetalert2";

const Transactions = () => {
    const { optionGroups, darkMode, openState, boxOpener, joinedTransactions, customers, customerType, accounts, texts, all_currencies } = useContext(MainContext);
    const [dateRange, setDateRange] = useState<any>([new Date(Date.now() - 72 * 60 * 60000), new Date()]);
    const [amountRange, setAmountRange] = useState<any>([0, 30000000]);
    const [inputRange, setInputRange] = useState(0);
    const [currency, setCurrency] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [fake, setFake] = useState(false);
    const [inputs, setInputs] = useState<any[]>([]);
    const [historyData, setHistoryData] = useState<any>({});
    const [profitable, setProfitable] = useState(false);
    const [looseFull, setLooseFull] = useState(false);

    const addInput = () => {
        setInputs([...inputs, { type: "", id: "" }]);
    };

    const removeInput = (index: number) => {
        setInputs(inputs.filter((_, i) => i !== index));
    };
    const selectStyles = {
        container: (base: any) => ({
            ...base,
            width: window.innerWidth <= 650 ? "310px" : "300px",
        }),
        control: (base: any, state: any) => ({
            ...base,
            borderColor: state.isDisabled ? "#333" : "gray",
            borderRadius: "0.5rem",
            padding: "0.5rem",
            boxShadow: "none",
            marginRight: window.innerWidth <= 650 ? "" : "15px",
            height: "56px",
            "&:hover": { borderColor: "blue" },
        }),
        option: (base: any, state: any) => ({
            ...base,
            backgroundColor: state.isSelected ? "#FEC901" : state.isFocused ? "lightgray" : "white",
            color: state.isSelected ? "black" : "black",
            "&:hover": {
                backgroundColor: "lightblue",
            },
        }),
        menu: (base: any) => ({
            ...base,
            marginTop: 0,
            borderRadius: "0.375rem",
        }),
        placeholder: (base: any) => ({
            ...base,
            color: "gray",
            fontSize: "0.875rem",
        }),
    };
    const transformOption = (option: any) => ({
        // isDisabled: option._id === prevInput?.place.accountId && option.currencies.length === 1,
        value: option,
        label: option?.name + (option?.type && option?.contact ? ` - ${option?.type}` : ""),
        customLabel: (
            <div className="flex items-center">
                <img
                    style={{
                        width: "30px",
                        height: "30px",
                        marginRight: "10px",
                        backgroundColor: "black",
                        borderRadius: "50%",
                        padding: "5px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                    }}
                    //@ts-ignore
                    src={option.contact ? icons.user : icons[option?.name?.toUpperCase()] ? icons[option?.name?.toUpperCase()] : option.icon ? process.env.REACT_APP_BACK_SRC + "/api/" + "icons/" + option.icon : icons["CANCEL"]}
                />
                {option?.name + (option.type && option.contact ? ` - ${option.type}` : "")}
            </div>
        ),
        type: option.contact ? "customerId" : "accountId",
    });

    const options = [...accounts, ...customers, ...customerType]
        .sort((a, b) => {
            const isAAccount = accounts.includes(a);
            const isBAccount = accounts.includes(b);

            if (isAAccount && !isBAccount) return -1;
            if (!isAAccount && isBAccount) return 1;

            return b.usability - a.usability;
        })
        .map(transformOption);

    const getFilteredHistory = async () => {
        const startDate = dateRange[0];
        const endDate = dateRange[1];
        const curr = currency?.value;
        console.log("loading set to true");
        setLoading(true);

        try {
            if (new Date(startDate).getTime() <= new Date(endDate).getTime()) {
                console.log("aaa");
                request
                    .post("/history/", { startDate: new Date(startDate.getTime() + 4 * 60 * 60 * 1000), endDate: new Date(endDate.getTime() + 4 * 60 * 60 * 1000), inputs, amountRange, curr, inputRange, profitable, looseFull })
                    .then((res) => {
                        setHistoryData(res.data);
                        setLoading(false);
                    })
                    .catch((err) => {
                        setLoading(false);
                        console.log(err);
                    });
            }
        } catch (error) {
            setLoading(false);
        }
    };
    console.log("loading", inputs);
    // Detect if device is mobile

    const returnables = window.localStorage.getItem("returnables");

    useEffect(() => {
        getFilteredHistory();
    }, []);

    return (
        <div
            className="transactions-page"
            style={{
                fontFamily: '"Work Sans", "Noto Sans", sans-serif',
                backgroundColor: darkMode ? "black" : "white",
                minHeight: "calc(100vh - 75px)",
            }}
        >
            <div className="layout-container" style={{ maxWidth: 960, margin: "0 auto" }}>
                <div className="header">
                    <div className="titleBlock">
                        <Typography variant="h4" fontWeight={800} color={darkMode ? "white" : "black"}>
                            {texts.transactions.transactions}
                        </Typography>
                        {(!joinedTransactions.length || loading) && (
                            <Box display="flex" justifyContent="center" alignItems="center" className="loader">
                                <CircularProgress color="inherit" />
                            </Box>
                        )}
                    </div>
                </div>

                {/* FILTERS SECTION */}
                <Paper
                    elevation={3}
                    sx={{
                        borderRadius: 3,
                        background: darkMode ? "#000" : "#fff",
                        mt: 2,
                        mb: 3,
                        p: { xs: 2, sm: 3 },
                        width: "100%",
                        border: "1px solid #fff",
                    }}
                >
                    <Select
                        id={"groupselect"}
                        options={optionGroups}
                        isClearable
                        required
                        styles={selectStyles}
                        onChange={(e: any) => {
                            console.log(e);
                            setInputs(e?.value || []);
                        }}
                    />
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center" justifyContent="space-between">
                        {/* Date Range Picker */}
                        <DatePicker
                            selected={dateRange[0]}
                            onChange={(date) => {
                                setDateRange([date, dateRange[1]]);
                                setTimeout(() => {
                                    //@ts-ignore
                                    document.activeElement?.blur();
                                }, 50);
                            }}
                            dateFormat="dd/MM/yyyy"
                            dropdownMode="select"
                            portalId="root-portal"
                            disabledKeyboardNavigation
                            onFocus={(e) => e.target.blur()}
                            className="p-2 m-2 border border-gray-300 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-800 dark:text-white hover:cursor-pointer"
                        />
                        <DatePicker
                            selected={dateRange[1]}
                            onChange={(date) => {
                                setDateRange([dateRange[0], date]);
                                setTimeout(() => {
                                    //@ts-ignore
                                    document.activeElement?.blur();
                                }, 50);
                            }}
                            dateFormat="dd/MM/yyyy"
                            disabledKeyboardNavigation
                            onFocus={(e) => e.target.blur()}
                            dropdownMode="select"
                            portalId="root-portal"
                            className="p-2 m-2 border border-gray-300 rounded-lg shadow-md focus:outline-none focus:ring-blue-500 dark:bg-gray-800 dark:text-white hover:cursor-pointer"
                        />
                        {/* Amount Range Selector */}
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                            }}
                        >
                            <Box sx={{ minWidth: 200, marginTop: "30px" }}>
                                <Typography variant="body2" color={darkMode ? "#fff" : "#232526"} fontWeight={600} mb={1}>
                                    {texts.transactions.amountRange}
                                </Typography>
                                <Slider
                                    value={amountRange}
                                    onChange={(_, v) => setAmountRange(v)}
                                    min={0}
                                    max={30000000}
                                    step={10}
                                    valueLabelDisplay="on"
                                    sx={{
                                        color: "#FEC901",
                                        "& .MuiSlider-thumb": {
                                            border: "2px solid #fff",
                                        },
                                        "& .MuiSlider-rail": {
                                            backgroundColor: "#fff",
                                        },
                                        "& .MuiSlider-track": {
                                            backgroundColor: "#fff",
                                        },
                                        "& .MuiSlider-valueLabel": {
                                            color: "#000",
                                        },
                                        marginTop: "25px",
                                        marginRight: "25px",
                                    }}
                                />
                            </Box>
                            <MoneyInput
                                type="text"
                                uppervalue={"Enter range"}
                                value={inputRange}
                                onChange={(value: string) => {
                                    const numberValue = Number(value);
                                    setInputRange(numberValue);
                                }}
                                placeholder="Avg"
                                undervalue={""}
                                style={{ width: window.innerWidth <= 650 ? "80%" : "200px" }}
                            />
                        </Box>

                        {/* Currency Selector */}
                        <Autocomplete
                            options={all_currencies.map((curr: any) => {
                                return { label: curr, value: curr };
                            })}
                            value={currency}
                            onChange={(_, value) => setCurrency(value)}
                            getOptionLabel={(option) => option.label}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            clearOnEscape
                            sx={{
                                minWidth: 120,
                                "& .MuiOutlinedInput-root": {
                                    color: "#fff",
                                    "& fieldset": {
                                        borderColor: "#fff",
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "#fff",
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "#fff",
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                    color: "#fff",
                                },
                                "& .MuiAutocomplete-popupIndicator": {
                                    color: "#fff",
                                },
                                "& .MuiAutocomplete-clearIndicator": {
                                    color: "#fff",
                                },
                                "& .MuiSvgIcon-root": {
                                    color: "#fff",
                                },
                            }}
                            size="small"
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={texts.transactions.currency}
                                    variant="outlined"
                                    InputLabelProps={{
                                        style: { color: "#fff" },
                                    }}
                                    InputProps={{
                                        ...params.InputProps,
                                        style: { color: "#fff", borderColor: "#fff" },
                                    }}
                                />
                            )}
                        />
                    </Stack>
                    <br />

                    <label
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            cursor: "pointer",
                            marginRight: "15px",
                        }}
                    >
                        <input type="checkbox" checked={profitable} onChange={() => setProfitable(!profitable)} className="hidden" />
                        <span className={`w-6 h-6 flex items-center justify-center border-2 border-gray-400 rounded transition-colors ${profitable ? "bg-blue-500 border-blue-500" : "bg-white"}`}>
                            {profitable && (
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-white" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" clipRule="evenodd" />
                                </svg>
                            )}
                        </span>
                        <span className="ml-2 text-gray-700" style={{ color: "white" }}>
                            Profitable
                        </span>
                    </label>
                    <label
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            cursor: "pointer",
                        }}
                    >
                        <input type="checkbox" checked={looseFull} onChange={() => setLooseFull(!looseFull)} className="hidden" />
                        <span className={`w-6 h-6 flex items-center justify-center border-2 border-gray-400 rounded transition-colors ${looseFull ? "bg-blue-500 border-blue-500" : "bg-white"}`}>
                            {looseFull && (
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-white" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" clipRule="evenodd" />
                                </svg>
                            )}
                        </span>
                        <span className="ml-2 text-gray-700" style={{ color: "white" }}>
                            Loosefull
                        </span>
                    </label>
                    <br />
                    {/* Dynamic Select Inputs */}
                    {inputs.map((input, index) => (
                        <div style={{ display: "flex", flexDirection: window.innerWidth < 600 ? "column" : "row", alignItems: "center" }}>
                            <div key={index} className="flex items-center gap-3 mb-3 mt-5">
                                <Select
                                    id={index.toString()}
                                    options={options}
                                    isClearable
                                    required
                                    styles={selectStyles}
                                    onChange={(e: any) => {
                                        const updatedInputs = [...inputs];

                                        updatedInputs[index] = {
                                            ...updatedInputs[index],
                                            type: e?.type === "customerId" ? "customer" : e?.type === "customer-type" ? "customer-type" : "account",
                                            id: e?.type === "customerId" ? e?.value?._id : e?.type === "customer-type" ? e?.value.type : e?.value?._id,
                                        };

                                        setInputs(updatedInputs);
                                    }}
                                    value={[...accounts, ...customers].filter((e) => e._id === input?.place?.customerId || e._id === input?.place?.accountId || e._id === input?.id)?.map(transformOption)[0]}
                                    getOptionLabel={(e: any) => e.customLabel} // Render custom JSX for the dropdown
                                    filterOption={(option: any, input) => {
                                        return option.data.label.toLowerCase().includes(input.toLowerCase()); // Filter based on plain text label
                                    }}
                                />
                            </div>
                            <div style={{ color: "white", display: "flex", marginRight: "10px" }}>
                                <p>Without: </p>
                                <input
                                    onChange={(e: any) => {
                                        const updatedInputs = [...inputs];

                                        updatedInputs[index] = {
                                            ...updatedInputs[index],
                                            without: e.target.checked,
                                        };

                                        setInputs(updatedInputs);
                                    }}
                                    checked={inputs[index].without}
                                    style={{ marginLeft: "5px", width: "20px", height: "20px" }}
                                    type="checkbox"
                                />
                            </div>
                            {/* Remove Button */}
                            <button type="button" onClick={() => removeInput(index)} className="w-10 h-10 flex items-center justify-center bg-gray-700 text-white rounded-lg font-bold">
                                X
                            </button>
                        </div>
                    ))}
                    <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                        {/* Add New Input Button */}
                        <button type="button" onClick={addInput} className="mt-4 px-4 py-2 bg-gray-800 text-white rounded-md">
                            + {texts.transactions.newPlace}
                        </button>
                        {/* <button style={{ display: "flex" }} type="button" onClick={getFilteredHistory} className="mt-4 px-4 py-2 bg-white rounded-md">
                            Find
                            {loading && (
                                <Box display="flex" justifyContent="center" alignItems="center" style={{ color: "black", marginLeft: "10px" }}>
                                    <CircularProgress color="inherit" size={20} />
                                </Box>
                            )}
                        </button> */}
                        <button
                            onClick={() => {
                                const name = window.prompt("Selction name");
                                request.post("/user/group/add/", { group: { name, inputs } }).then(() => {
                                    Swal.fire({ icon: "success", title: "saved" });
                                });
                            }}
                            className="flex mt-4 px-4 py-2 bg-white rounded-md"
                        >
                            Save Selection
                        </button>
                        <button disabled={loading} className="flex mt-4 px-4 py-2 bg-white rounded-md" type="button" onClick={getFilteredHistory}>
                            <span style={{ marginRight: "5px" }} className="submit-label">
                                Find
                            </span>
                            {loading && (
                                <Box display="flex" justifyContent="center" alignItems="center" style={{ color: "black" }}>
                                    <CircularProgress color="inherit" size={20} />
                                </Box>
                            )}
                        </button>
                    </div>
                </Paper>

                <CollapsableBox title={texts.transactions.history} isOpen={openState.history} setIsOpen={() => boxOpener("history")}>
                    <History startDate={dateRange[0]} endDate={dateRange[1]} inputs={inputs} historyData={historyData} getFilteredHistory={getFilteredHistory} loading={loading} />
                </CollapsableBox>

                <TransactionListPrev fake={fake} setFake={setFake} transactions={returnables ? JSON.parse(returnables) : []} date={dateRange[0]} getFilteredHistory={getFilteredHistory} />
                <CollapsableBox title={texts.transactions.addTransaction} isOpen={openState.addTransaction} setIsOpen={() => boxOpener("addTransaction")}>
                    <AddTransaction lastTime={(returnables ? JSON.parse(returnables) : []).sort((a: any, b: any) => new Date(a.timeStamp).getTime() - new Date(b.timeStamp).getTime())[0]?.timeStamp} getFilteredHistory={getFilteredHistory} />
                </CollapsableBox>
                <TransactionList transactions={historyData?.transactions} dateRange={dateRange} amountRange={amountRange} currency={currency} getFilteredHistory={getFilteredHistory} />
            </div>
        </div>
    );
};

export default Transactions;
